import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  LinearProgress,
} from "@mui/material";
import moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { fetchData, currentFormat } from "../js/main";
import { conf } from "../const";
import PageBar from "./PageBar";

const tableHeads = [
  { label: "ประเภทรายได้" },
  { label: "การรับเงิน" },
  { label: "ใบเสร็จเลขที่" },
  { label: "เวลารับเงิน" },
  { label: "จำนวนเงิน" },
  { label: "หมายเหตุ", style: { width: "1.5cm" } },
];

export default function DeliveryHistory(props) {
  const [filter, setFilter] = useState();
  const [deliveries, setDeliveries] = useState();
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    (async () => {
      if (props.profile) {
        setFilter({
          limit: 50,
          skip: 0,
          match: {
            usn: props.profile.usn,
          },
          sort: { toDate: 1, toTime: 1 },
        });
      }
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
      if (filter) {
        setLoading(true);
        const deliveries = await fetchData("post", "/v3/delivery", filter);

        let count = Math.ceil(deliveries.count / filter.limit);
        if (count < 1) count = 1;
        setPageCount(count);

        setDeliveries(deliveries);
        setLoading(false);
      }
    })();
  }, [filter]);

  async function print(form) {
    let print = {
      headers: [
        { label: "หลักฐานการส่งเงิน" },
        {
          label: `ตั้งแต่ ${moment(form.fromDate).format("DD MMM YYYY")} เวลา ${
            form.fromTime
          } น. ถึง ${moment(form.toDate).format("DD MMM YYYY")} เวลา ${
            form.toTime
          } น.`,
        },
      ],
      create_date: form.create_date,
      create_usn: form.usn,
      table: {
        cols: tableHeads,
        rows: [],
        total: form.total,
      },
    };
    print.table.rows = await form.bills.map((bill) => {
      let r = {
        col_0: [],
        col_1: bill.transactionType,
        col_2: bill.bill_id,
        col_3: moment(bill.transactionDateandTime).format("DD MMM YYYY, HH:mm"),
        col_4: currentFormat(bill.amount),
        col_5: bill.canceled.status === true ? "ยกเลิก" : "",
      };
      for (const detail of bill.invoice_id.details) {
        r.col_0.push({ label: detail.biller_name });
      }
      return r;
    });
    let cookie = JSON.parse(localStorage.getItem(conf.cookiePrint));
    if (!cookie) cookie = { print: {} };
    cookie.print = print;
    localStorage.setItem(conf.cookiePrint, JSON.stringify(cookie));
    document.getElementById("printFrame").src =
      process.env.PUBLIC_URL + "/print/delivery";
  }
  function changePage(no) {
    let skip = (no - 1) * filter.limit;
    setFilter({ ...filter, skip });
    setPageNo(no);
  }
  function showAllDelivery(e) {
    const { checked } = e.target;
    setShowAll(checked);
    if (checked === true) {
      setFilter({
        ...filter,
        skip: 0,
        match: {},
      });
    } else {
      setFilter({
        ...filter,
        skip: 0,
        match: {
          usn: props.profile.usn,
        },
      });
    }
  }
  return (
    <div style={{ paddingTop: "5px" }}>
      {deliveries && (
        <>
          <Grid container>
            <Grid item xs={12} md={6} style={{ paddingTop: "10px" }}>
              <PageBar
                onChangePage={changePage}
                count={pageCount}
                pageNo={pageNo}
              />
            </Grid>
            <Grid item xs={12} md={6} align="right">
              <FormGroup sx={{ width: "130px" }}>
                <FormControlLabel
                  control={<Checkbox checked={showAll} />}
                  label={<div>แสดงทั้งหมด</div>}
                  onChange={showAllDelivery}
                />
              </FormGroup>
            </Grid>
          </Grid>
          <DeliveryTable
            deliveries={deliveries}
            skip={filter.skip}
            onPrint={print}
            loading={loading}
          />
        </>
      )}
    </div>
  );
}

function DeliveryTable({ deliveries, skip, loading, onPrint }) {
  return (
    <div style={{ paddingTop: "15px" }}>
      {loading === true && <LinearProgress />}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "100px" }}>No</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Bill Count</TableCell>
              <TableCell>Coins</TableCell>
              <TableCell>Banknote</TableCell>
              <TableCell>Transfers</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell sx={{ width: "80px" }}>Print</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveries.result.map((dvr, key) => (
              <TableRow key={key}>
                <TableCell align="center">{key + skip + 1}</TableCell>
                <TableCell align="center">
                  {moment(dvr.fromSysTime).format("DD MMM YYYY, HH:mm")}
                </TableCell>
                <TableCell align="center">
                  {moment(dvr.toSysTime).format("DD MMM YYYY, HH:mm")}
                </TableCell>
                <TableCell align="center">{dvr.bills.length}</TableCell>
                <TableCell align="center">
                  {currentFormat(dvr.coin_amount)}
                </TableCell>
                <TableCell align="center">
                  {currentFormat(dvr.banknote_amount)}
                </TableCell>
                <TableCell align="center">
                  {currentFormat(dvr.total.transfer)}
                </TableCell>
                <TableCell align="center">
                  {currentFormat(dvr.total.amount)}
                </TableCell>
                <TableCell align="center" className="inputPadding">
                  <IconButton
                    color="primary"
                    sx={{ padding: "5px 5px" }}
                    onClick={() => onPrint(dvr)}
                  >
                    <Icon>print</Icon>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
